import React from 'react';

import s from './moneyBackGuaranteeContent.scss';

/**
 * "Money Back Guarantee" popup
 * @param {PropsType} props - component props
 * @constructor
 */
export const MoneyBackGuaranteeContent = () => (
    <>
        <div className={s.container}>
            <h4 className={s.title}>Money Back Guaranteed</h4>

            <p className={s.content}>
                At GlassesUSA.com, return and exchanges are made easy. We do our best to make
                returns and exchanges as easy as possible. We are pretty confident that you&#39;ll
                love our product. Howewer, if for some reason or other you&#39;re not completely
                satisfied with your glasses within the first 14 days of receiving them, you are
                entitled to a money back return or 100% store credit. No questions asked and
                hassle-free.
            </p>
        </div>
    </>
);
